import { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';

import { BridgeKycStatus } from 'types/cryptoPayout';

import { statusToLabelMap } from './keys';
import { BadgeContent } from './styles';

interface BridgeKycStatusBadgeProps {
  status: BridgeKycStatus;
}

const badgeToIconMap: Record<BridgeKycStatus, ReactElement | null> = {
  [BridgeKycStatus.Active]: <IconChecked />,
  [BridgeKycStatus.Paused]: <IconCross />,
  [BridgeKycStatus.Pending]: <IconRefresh />,
  [BridgeKycStatus.Approved]: <IconChecked />,
  [BridgeKycStatus.Incomplete]: <IconRefresh />,
  [BridgeKycStatus.Rejected]: <IconCross />,
  [BridgeKycStatus.AwaitingUbo]: <IconRefresh />,
  [BridgeKycStatus.NotStarted]: <IconRefresh />,
  [BridgeKycStatus.UnderReview]: <IconCross />,
  [BridgeKycStatus.ManualReview]: <IconCross />,
};

const badgeTypeMap: Record<BridgeKycStatus, BadgeType> = {
  [BridgeKycStatus.Active]: BadgeType.Success,
  [BridgeKycStatus.Paused]: BadgeType.Fail,
  [BridgeKycStatus.Pending]: BadgeType.Default,
  [BridgeKycStatus.Approved]: BadgeType.Success,
  [BridgeKycStatus.Incomplete]: BadgeType.Default,
  [BridgeKycStatus.Rejected]: BadgeType.Fail,
  [BridgeKycStatus.AwaitingUbo]: BadgeType.Default,
  [BridgeKycStatus.NotStarted]: BadgeType.Default,
  [BridgeKycStatus.UnderReview]: BadgeType.Fail,
  [BridgeKycStatus.ManualReview]: BadgeType.Fail,
};

export const BridgeKycStatusBadge = ({ status }: BridgeKycStatusBadgeProps) => {
  const { type, label } = statusToLabelMap[status];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
